import { gql } from '@apollo/client';

const GET_COMMAND_LOG = gql`
    query getCommandLog($DeviceUDID: String!) {
        commandlogs(DeviceUDID: $DeviceUDID) {
            CommandUUID
            RequestType
            Requester
            Approver
            Response
            ErrorDetails
            PushResult
            createdAt
            updatedAt
    }
}`

export { GET_COMMAND_LOG };
